import Icon from '@ant-design/icons';
import React from 'react';

const OrderConfirmedSvg = (props: React.HTMLAttributes<SVGElement>) => (
  <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.3333 2.66666H15.76C15.2 1.12 13.7333 0 12 0C10.2667 0 8.8 1.12 8.24 2.66666H2.66667C1.2 2.66666 0 3.86666 0 5.33333V24C0 25.4666 1.2 26.6666 2.66667 26.6666H21.3333C22.8 26.6666 24 25.4666 24 24V5.33333C24 3.86666 22.8 2.66666 21.3333 2.66666ZM12 2.66666C12.7333 2.66666 13.3333 3.26666 13.3333 4C13.3333 4.73333 12.7333 5.33333 12 5.33333C11.2667 5.33333 10.6667 4.73333 10.6667 4C10.6667 3.26666 11.2667 2.66666 12 2.66666ZM9.33333 21.3333L4 16L5.88 14.12L9.33333 17.56L18.12 8.77333L20 10.6667L9.33333 21.3333Z"
      fill="#202426"
    />
  </svg>
);

export const OrderConfirmedIcon = ({ className, ...props }: React.ComponentProps<typeof Icon>) => (
  <Icon component={() => <OrderConfirmedSvg className={className} />} {...props} />
);
